/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTravelersRouteImport } from './routes/_authenticated/travelers'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedBookingsRouteImport } from './routes/_authenticated/bookings'
import { Route as AuthenticatedHotelsRouteRouteImport } from './routes/_authenticated/hotels/route'
import { Route as AuthenticatedFlightsRouteRouteImport } from './routes/_authenticated/flights/route'
import { Route as AuthenticatedTripsSearchRouteImport } from './routes/_authenticated/trips/search'
import { Route as AuthenticatedHotelsSearchRouteImport } from './routes/_authenticated/hotels/search'
import { Route as AuthenticatedHotelsExternalRouteImport } from './routes/_authenticated/hotels/external'
import { Route as AuthenticatedFlightsSearchRouteImport } from './routes/_authenticated/flights/search'
import { Route as AuthenticatedFlightsExternalRouteImport } from './routes/_authenticated/flights/external'
import { Route as AuthenticatedTripsTripIdRouteRouteImport } from './routes/_authenticated/trips/$tripId/route'
import { Route as AuthenticatedHotelsHotelsRouteRouteImport } from './routes/_authenticated/hotels/_hotels/route'
import { Route as AuthenticatedFlightsFlightsRouteRouteImport } from './routes/_authenticated/flights/_flights/route'
import { Route as AuthenticatedTripsTripIdIndexRouteImport } from './routes/_authenticated/trips/$tripId/index'
import { Route as AuthenticatedTripsTripIdTravellersRouteImport } from './routes/_authenticated/trips/$tripId/travellers'
import { Route as AuthenticatedTripsTripIdSummaryRouteImport } from './routes/_authenticated/trips/$tripId/summary'
import { Route as AuthenticatedTripsTripIdSuccessRouteImport } from './routes/_authenticated/trips/$tripId/success'
import { Route as AuthenticatedTripsTripIdBookingRouteImport } from './routes/_authenticated/trips/$tripId/booking'
import { Route as AuthenticatedHotelsHotelsListRouteImport } from './routes/_authenticated/hotels/_hotels/list'
import { Route as AuthenticatedBookingsScopeIdRouteImport } from './routes/_authenticated/bookings_.$scope.$id'
import { Route as AuthenticatedHotelsHotelsHotelOfferRouteRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/route'
import { Route as AuthenticatedFlightsFlightsFlightOfferRouteRouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/route'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id'
import { Route as AuthenticatedFlightsFlightsReturnListRouteImport } from './routes/_authenticated/flights/_flights/return/list'
import { Route as AuthenticatedFlightsFlightsReturnFareRouteImport } from './routes/_authenticated/flights/_flights/return/fare'
import { Route as AuthenticatedFlightsFlightsDepartureListRouteImport } from './routes/_authenticated/flights/_flights/departure/list'
import { Route as AuthenticatedFlightsFlightsDepartureFareRouteImport } from './routes/_authenticated/flights/_flights/departure/fare'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdTravelersRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.travelers'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdSummaryRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.summary'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRoomsRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.rooms'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdDetailsRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.details'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdConfirmationRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.confirmation'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.details_.images'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.rooms_.$roomToken.images'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.details_.images_.fullscreen'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.final'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStep3RouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.3'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStep1RouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.1'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.2/index'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.rooms_.$roomToken.images_.fullscreen'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.2/additional-services/index'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.2/additional-services/meal-selection'
import { Route as AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRouteImport } from './routes/_authenticated/flights/_flights/_flight-offer/offer.$id.step.2/additional-services/baggage-selection'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTravelersRoute = AuthenticatedTravelersRouteImport.update({
  id: '/travelers',
  path: '/travelers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBookingsRoute = AuthenticatedBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHotelsRouteRoute =
  AuthenticatedHotelsRouteRouteImport.update({
    id: '/hotels',
    path: '/hotels',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFlightsRouteRoute =
  AuthenticatedFlightsRouteRouteImport.update({
    id: '/flights',
    path: '/flights',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTripsSearchRoute =
  AuthenticatedTripsSearchRouteImport.update({
    id: '/trips/search',
    path: '/trips/search',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsSearchRoute =
  AuthenticatedHotelsSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedHotelsRouteRoute,
  } as any)
const AuthenticatedHotelsExternalRoute =
  AuthenticatedHotelsExternalRouteImport.update({
    id: '/external',
    path: '/external',
    getParentRoute: () => AuthenticatedHotelsRouteRoute,
  } as any)
const AuthenticatedFlightsSearchRoute =
  AuthenticatedFlightsSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedFlightsRouteRoute,
  } as any)
const AuthenticatedFlightsExternalRoute =
  AuthenticatedFlightsExternalRouteImport.update({
    id: '/external',
    path: '/external',
    getParentRoute: () => AuthenticatedFlightsRouteRoute,
  } as any)
const AuthenticatedTripsTripIdRouteRoute =
  AuthenticatedTripsTripIdRouteRouteImport.update({
    id: '/trips/$tripId',
    path: '/trips/$tripId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsHotelsRouteRoute =
  AuthenticatedHotelsHotelsRouteRouteImport.update({
    id: '/_hotels',
    getParentRoute: () => AuthenticatedHotelsRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsRouteRoute =
  AuthenticatedFlightsFlightsRouteRouteImport.update({
    id: '/_flights',
    getParentRoute: () => AuthenticatedFlightsRouteRoute,
  } as any)
const AuthenticatedTripsTripIdIndexRoute =
  AuthenticatedTripsTripIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdTravellersRoute =
  AuthenticatedTripsTripIdTravellersRouteImport.update({
    id: '/travellers',
    path: '/travellers',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdSummaryRoute =
  AuthenticatedTripsTripIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdSuccessRoute =
  AuthenticatedTripsTripIdSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdBookingRoute =
  AuthenticatedTripsTripIdBookingRouteImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsListRoute =
  AuthenticatedHotelsHotelsListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthenticatedHotelsHotelsRouteRoute,
  } as any)
const AuthenticatedBookingsScopeIdRoute =
  AuthenticatedBookingsScopeIdRouteImport.update({
    id: '/bookings_/$scope/$id',
    path: '/bookings/$scope/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferRouteRoute =
  AuthenticatedHotelsHotelsHotelOfferRouteRouteImport.update({
    id: '/_hotel-offer',
    getParentRoute: () => AuthenticatedHotelsHotelsRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsFlightOfferRouteRoute =
  AuthenticatedFlightsFlightsFlightOfferRouteRouteImport.update({
    id: '/_flight-offer',
    getParentRoute: () => AuthenticatedFlightsFlightsRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsReturnListRoute =
  AuthenticatedFlightsFlightsReturnListRouteImport.update({
    id: '/return/list',
    path: '/return/list',
    getParentRoute: () => AuthenticatedFlightsFlightsRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsReturnFareRoute =
  AuthenticatedFlightsFlightsReturnFareRouteImport.update({
    id: '/return/fare',
    path: '/return/fare',
    getParentRoute: () => AuthenticatedFlightsFlightsRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsDepartureListRoute =
  AuthenticatedFlightsFlightsDepartureListRouteImport.update({
    id: '/departure/list',
    path: '/departure/list',
    getParentRoute: () => AuthenticatedFlightsFlightsRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsDepartureFareRoute =
  AuthenticatedFlightsFlightsDepartureFareRouteImport.update({
    id: '/departure/fare',
    path: '/departure/fare',
    getParentRoute: () => AuthenticatedFlightsFlightsRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute =
  AuthenticatedHotelsHotelsHotelOfferIdTravelersRouteImport.update({
    id: '/travelers',
    path: '/travelers',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute =
  AuthenticatedHotelsHotelsHotelOfferIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRouteImport.update({
    id: '/rooms',
    path: '/rooms',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute =
  AuthenticatedHotelsHotelsHotelOfferIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute =
  AuthenticatedHotelsHotelsHotelOfferIdConfirmationRouteImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute =
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRouteImport.update({
    id: '/details_/images',
    path: '/details/images',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRouteImport.update({
    id: '/rooms_/$roomToken/images',
    path: '/rooms/$roomToken/images',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute =
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRouteImport.update(
    {
      id: '/details_/images_/fullscreen',
      path: '/details/images/fullscreen',
      getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
    } as any,
  )
const AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRouteImport.update({
    id: '/offer/$id/step/final',
    path: '/offer/$id/step/final',
    getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep3RouteImport.update({
    id: '/offer/$id/step/3',
    path: '/offer/$id/step/3',
    getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep1RouteImport.update({
    id: '/offer/$id/step/1',
    path: '/offer/$id/step/1',
    getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
  } as any)
const AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRouteImport.update({
    id: '/offer/$id/step/2/',
    path: '/offer/$id/step/2/',
    getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRouteImport.update(
    {
      id: '/rooms_/$roomToken/images_/fullscreen',
      path: '/rooms/$roomToken/images/fullscreen',
      getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
    } as any,
  )
const AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRouteImport.update(
    {
      id: '/offer/$id/step/2/additional-services/',
      path: '/offer/$id/step/2/additional-services/',
      getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
    } as any,
  )
const AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRouteImport.update(
    {
      id: '/offer/$id/step/2/additional-services/meal-selection',
      path: '/offer/$id/step/2/additional-services/meal-selection',
      getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
    } as any,
  )
const AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute =
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRouteImport.update(
    {
      id: '/offer/$id/step/2/additional-services/baggage-selection',
      path: '/offer/$id/step/2/additional-services/baggage-selection',
      getParentRoute: () => AuthenticatedFlightsFlightsFlightOfferRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/flights': typeof AuthenticatedFlightsFlightsFlightOfferRouteRouteWithChildren
  '/hotels': typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  '/bookings': typeof AuthenticatedBookingsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/travelers': typeof AuthenticatedTravelersRoute
  '/': typeof AuthenticatedIndexRoute
  '/trips/$tripId': typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  '/flights/external': typeof AuthenticatedFlightsExternalRoute
  '/flights/search': typeof AuthenticatedFlightsSearchRoute
  '/hotels/external': typeof AuthenticatedHotelsExternalRoute
  '/hotels/search': typeof AuthenticatedHotelsSearchRoute
  '/trips/search': typeof AuthenticatedTripsSearchRoute
  '/bookings/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/trips/$tripId/': typeof AuthenticatedTripsTripIdIndexRoute
  '/flights/departure/fare': typeof AuthenticatedFlightsFlightsDepartureFareRoute
  '/flights/departure/list': typeof AuthenticatedFlightsFlightsDepartureListRoute
  '/flights/return/fare': typeof AuthenticatedFlightsFlightsReturnFareRoute
  '/flights/return/list': typeof AuthenticatedFlightsFlightsReturnListRoute
  '/hotels/$id': typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
  '/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  '/hotels/$id/details': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  '/hotels/$id/rooms': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  '/hotels/$id/summary': typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  '/hotels/$id/travelers': typeof AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute
  '/hotels/$id/details/images': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  '/flights/offer/$id/step/1': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route
  '/flights/offer/$id/step/3': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route
  '/flights/offer/$id/step/final': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute
  '/hotels/$id/details/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  '/hotels/$id/rooms/$roomToken/images': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute
  '/hotels/$id/rooms/$roomToken/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
  '/flights/offer/$id/step/2': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute
  '/flights/offer/$id/step/2/additional-services/baggage-selection': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute
  '/flights/offer/$id/step/2/additional-services/meal-selection': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute
  '/flights/offer/$id/step/2/additional-services': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/flights': typeof AuthenticatedFlightsFlightsFlightOfferRouteRouteWithChildren
  '/hotels': typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  '/bookings': typeof AuthenticatedBookingsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/travelers': typeof AuthenticatedTravelersRoute
  '/': typeof AuthenticatedIndexRoute
  '/flights/external': typeof AuthenticatedFlightsExternalRoute
  '/flights/search': typeof AuthenticatedFlightsSearchRoute
  '/hotels/external': typeof AuthenticatedHotelsExternalRoute
  '/hotels/search': typeof AuthenticatedHotelsSearchRoute
  '/trips/search': typeof AuthenticatedTripsSearchRoute
  '/bookings/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/trips/$tripId': typeof AuthenticatedTripsTripIdIndexRoute
  '/flights/departure/fare': typeof AuthenticatedFlightsFlightsDepartureFareRoute
  '/flights/departure/list': typeof AuthenticatedFlightsFlightsDepartureListRoute
  '/flights/return/fare': typeof AuthenticatedFlightsFlightsReturnFareRoute
  '/flights/return/list': typeof AuthenticatedFlightsFlightsReturnListRoute
  '/hotels/$id': typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
  '/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  '/hotels/$id/details': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  '/hotels/$id/rooms': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  '/hotels/$id/summary': typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  '/hotels/$id/travelers': typeof AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute
  '/hotels/$id/details/images': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  '/flights/offer/$id/step/1': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route
  '/flights/offer/$id/step/3': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route
  '/flights/offer/$id/step/final': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute
  '/hotels/$id/details/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  '/hotels/$id/rooms/$roomToken/images': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute
  '/hotels/$id/rooms/$roomToken/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
  '/flights/offer/$id/step/2': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute
  '/flights/offer/$id/step/2/additional-services/baggage-selection': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute
  '/flights/offer/$id/step/2/additional-services/meal-selection': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute
  '/flights/offer/$id/step/2/additional-services': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/flights': typeof AuthenticatedFlightsRouteRouteWithChildren
  '/_authenticated/hotels': typeof AuthenticatedHotelsRouteRouteWithChildren
  '/_authenticated/bookings': typeof AuthenticatedBookingsRoute
  '/_authenticated/chat': typeof AuthenticatedChatRoute
  '/_authenticated/travelers': typeof AuthenticatedTravelersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/flights/_flights': typeof AuthenticatedFlightsFlightsRouteRouteWithChildren
  '/_authenticated/hotels/_hotels': typeof AuthenticatedHotelsHotelsRouteRouteWithChildren
  '/_authenticated/trips/$tripId': typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  '/_authenticated/flights/external': typeof AuthenticatedFlightsExternalRoute
  '/_authenticated/flights/search': typeof AuthenticatedFlightsSearchRoute
  '/_authenticated/hotels/external': typeof AuthenticatedHotelsExternalRoute
  '/_authenticated/hotels/search': typeof AuthenticatedHotelsSearchRoute
  '/_authenticated/trips/search': typeof AuthenticatedTripsSearchRoute
  '/_authenticated/flights/_flights/_flight-offer': typeof AuthenticatedFlightsFlightsFlightOfferRouteRouteWithChildren
  '/_authenticated/hotels/_hotels/_hotel-offer': typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  '/_authenticated/bookings_/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/_authenticated/hotels/_hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/_authenticated/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/_authenticated/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/_authenticated/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/_authenticated/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/_authenticated/trips/$tripId/': typeof AuthenticatedTripsTripIdIndexRoute
  '/_authenticated/flights/_flights/departure/fare': typeof AuthenticatedFlightsFlightsDepartureFareRoute
  '/_authenticated/flights/_flights/departure/list': typeof AuthenticatedFlightsFlightsDepartureListRoute
  '/_authenticated/flights/_flights/return/fare': typeof AuthenticatedFlightsFlightsReturnFareRoute
  '/_authenticated/flights/_flights/return/list': typeof AuthenticatedFlightsFlightsReturnListRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id': typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation': typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/details': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary': typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/travelers': typeof AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/1': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/3': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/final': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/baggage-selection': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/meal-selection': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute
  '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/': typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/flights'
    | '/hotels'
    | '/bookings'
    | '/chat'
    | '/travelers'
    | '/'
    | '/trips/$tripId'
    | '/flights/external'
    | '/flights/search'
    | '/hotels/external'
    | '/hotels/search'
    | '/trips/search'
    | '/bookings/$scope/$id'
    | '/hotels/list'
    | '/trips/$tripId/booking'
    | '/trips/$tripId/success'
    | '/trips/$tripId/summary'
    | '/trips/$tripId/travellers'
    | '/trips/$tripId/'
    | '/flights/departure/fare'
    | '/flights/departure/list'
    | '/flights/return/fare'
    | '/flights/return/list'
    | '/hotels/$id'
    | '/hotels/$id/confirmation'
    | '/hotels/$id/details'
    | '/hotels/$id/rooms'
    | '/hotels/$id/summary'
    | '/hotels/$id/travelers'
    | '/hotels/$id/details/images'
    | '/flights/offer/$id/step/1'
    | '/flights/offer/$id/step/3'
    | '/flights/offer/$id/step/final'
    | '/hotels/$id/details/images/fullscreen'
    | '/hotels/$id/rooms/$roomToken/images'
    | '/hotels/$id/rooms/$roomToken/images/fullscreen'
    | '/flights/offer/$id/step/2'
    | '/flights/offer/$id/step/2/additional-services/baggage-selection'
    | '/flights/offer/$id/step/2/additional-services/meal-selection'
    | '/flights/offer/$id/step/2/additional-services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/flights'
    | '/hotels'
    | '/bookings'
    | '/chat'
    | '/travelers'
    | '/'
    | '/flights/external'
    | '/flights/search'
    | '/hotels/external'
    | '/hotels/search'
    | '/trips/search'
    | '/bookings/$scope/$id'
    | '/hotels/list'
    | '/trips/$tripId/booking'
    | '/trips/$tripId/success'
    | '/trips/$tripId/summary'
    | '/trips/$tripId/travellers'
    | '/trips/$tripId'
    | '/flights/departure/fare'
    | '/flights/departure/list'
    | '/flights/return/fare'
    | '/flights/return/list'
    | '/hotels/$id'
    | '/hotels/$id/confirmation'
    | '/hotels/$id/details'
    | '/hotels/$id/rooms'
    | '/hotels/$id/summary'
    | '/hotels/$id/travelers'
    | '/hotels/$id/details/images'
    | '/flights/offer/$id/step/1'
    | '/flights/offer/$id/step/3'
    | '/flights/offer/$id/step/final'
    | '/hotels/$id/details/images/fullscreen'
    | '/hotels/$id/rooms/$roomToken/images'
    | '/hotels/$id/rooms/$roomToken/images/fullscreen'
    | '/flights/offer/$id/step/2'
    | '/flights/offer/$id/step/2/additional-services/baggage-selection'
    | '/flights/offer/$id/step/2/additional-services/meal-selection'
    | '/flights/offer/$id/step/2/additional-services'
  id:
    | '__root__'
    | '/$'
    | '/_authenticated'
    | '/_authenticated/flights'
    | '/_authenticated/hotels'
    | '/_authenticated/bookings'
    | '/_authenticated/chat'
    | '/_authenticated/travelers'
    | '/_authenticated/'
    | '/_authenticated/flights/_flights'
    | '/_authenticated/hotels/_hotels'
    | '/_authenticated/trips/$tripId'
    | '/_authenticated/flights/external'
    | '/_authenticated/flights/search'
    | '/_authenticated/hotels/external'
    | '/_authenticated/hotels/search'
    | '/_authenticated/trips/search'
    | '/_authenticated/flights/_flights/_flight-offer'
    | '/_authenticated/hotels/_hotels/_hotel-offer'
    | '/_authenticated/bookings_/$scope/$id'
    | '/_authenticated/hotels/_hotels/list'
    | '/_authenticated/trips/$tripId/booking'
    | '/_authenticated/trips/$tripId/success'
    | '/_authenticated/trips/$tripId/summary'
    | '/_authenticated/trips/$tripId/travellers'
    | '/_authenticated/trips/$tripId/'
    | '/_authenticated/flights/_flights/departure/fare'
    | '/_authenticated/flights/_flights/departure/list'
    | '/_authenticated/flights/_flights/return/fare'
    | '/_authenticated/flights/_flights/return/list'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/details'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/travelers'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/1'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/3'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/final'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/baggage-selection'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/meal-selection'
    | '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/travelers': {
      id: '/_authenticated/travelers'
      path: '/travelers'
      fullPath: '/travelers'
      preLoaderRoute: typeof AuthenticatedTravelersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat': {
      id: '/_authenticated/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings': {
      id: '/_authenticated/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof AuthenticatedBookingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels': {
      id: '/_authenticated/hotels'
      path: '/hotels'
      fullPath: '/hotels'
      preLoaderRoute: typeof AuthenticatedHotelsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flights': {
      id: '/_authenticated/flights'
      path: '/flights'
      fullPath: '/flights'
      preLoaderRoute: typeof AuthenticatedFlightsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trips/search': {
      id: '/_authenticated/trips/search'
      path: '/trips/search'
      fullPath: '/trips/search'
      preLoaderRoute: typeof AuthenticatedTripsSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels/search': {
      id: '/_authenticated/hotels/search'
      path: '/search'
      fullPath: '/hotels/search'
      preLoaderRoute: typeof AuthenticatedHotelsSearchRouteImport
      parentRoute: typeof AuthenticatedHotelsRouteRoute
    }
    '/_authenticated/hotels/external': {
      id: '/_authenticated/hotels/external'
      path: '/external'
      fullPath: '/hotels/external'
      preLoaderRoute: typeof AuthenticatedHotelsExternalRouteImport
      parentRoute: typeof AuthenticatedHotelsRouteRoute
    }
    '/_authenticated/flights/search': {
      id: '/_authenticated/flights/search'
      path: '/search'
      fullPath: '/flights/search'
      preLoaderRoute: typeof AuthenticatedFlightsSearchRouteImport
      parentRoute: typeof AuthenticatedFlightsRouteRoute
    }
    '/_authenticated/flights/external': {
      id: '/_authenticated/flights/external'
      path: '/external'
      fullPath: '/flights/external'
      preLoaderRoute: typeof AuthenticatedFlightsExternalRouteImport
      parentRoute: typeof AuthenticatedFlightsRouteRoute
    }
    '/_authenticated/trips/$tripId': {
      id: '/_authenticated/trips/$tripId'
      path: '/trips/$tripId'
      fullPath: '/trips/$tripId'
      preLoaderRoute: typeof AuthenticatedTripsTripIdRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels/_hotels': {
      id: '/_authenticated/hotels/_hotels'
      path: ''
      fullPath: '/hotels'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsRouteRouteImport
      parentRoute: typeof AuthenticatedHotelsRouteRoute
    }
    '/_authenticated/flights/_flights': {
      id: '/_authenticated/flights/_flights'
      path: ''
      fullPath: '/flights'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsRouteRouteImport
      parentRoute: typeof AuthenticatedFlightsRouteRoute
    }
    '/_authenticated/trips/$tripId/': {
      id: '/_authenticated/trips/$tripId/'
      path: '/'
      fullPath: '/trips/$tripId/'
      preLoaderRoute: typeof AuthenticatedTripsTripIdIndexRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/travellers': {
      id: '/_authenticated/trips/$tripId/travellers'
      path: '/travellers'
      fullPath: '/trips/$tripId/travellers'
      preLoaderRoute: typeof AuthenticatedTripsTripIdTravellersRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/summary': {
      id: '/_authenticated/trips/$tripId/summary'
      path: '/summary'
      fullPath: '/trips/$tripId/summary'
      preLoaderRoute: typeof AuthenticatedTripsTripIdSummaryRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/success': {
      id: '/_authenticated/trips/$tripId/success'
      path: '/success'
      fullPath: '/trips/$tripId/success'
      preLoaderRoute: typeof AuthenticatedTripsTripIdSuccessRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/booking': {
      id: '/_authenticated/trips/$tripId/booking'
      path: '/booking'
      fullPath: '/trips/$tripId/booking'
      preLoaderRoute: typeof AuthenticatedTripsTripIdBookingRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/hotels/_hotels/list': {
      id: '/_authenticated/hotels/_hotels/list'
      path: '/list'
      fullPath: '/hotels/list'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsListRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsRouteRoute
    }
    '/_authenticated/bookings_/$scope/$id': {
      id: '/_authenticated/bookings_/$scope/$id'
      path: '/bookings/$scope/$id'
      fullPath: '/bookings/$scope/$id'
      preLoaderRoute: typeof AuthenticatedBookingsScopeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer'
      path: ''
      fullPath: '/hotels'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsRouteRoute
    }
    '/_authenticated/flights/_flights/_flight-offer': {
      id: '/_authenticated/flights/_flights/_flight-offer'
      path: ''
      fullPath: '/flights'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id'
      path: '/$id'
      fullPath: '/hotels/$id'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferRouteRoute
    }
    '/_authenticated/flights/_flights/return/list': {
      id: '/_authenticated/flights/_flights/return/list'
      path: '/return/list'
      fullPath: '/flights/return/list'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsReturnListRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsRouteRoute
    }
    '/_authenticated/flights/_flights/return/fare': {
      id: '/_authenticated/flights/_flights/return/fare'
      path: '/return/fare'
      fullPath: '/flights/return/fare'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsReturnFareRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsRouteRoute
    }
    '/_authenticated/flights/_flights/departure/list': {
      id: '/_authenticated/flights/_flights/departure/list'
      path: '/departure/list'
      fullPath: '/flights/departure/list'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsDepartureListRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsRouteRoute
    }
    '/_authenticated/flights/_flights/departure/fare': {
      id: '/_authenticated/flights/_flights/departure/fare'
      path: '/departure/fare'
      fullPath: '/flights/departure/fare'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsDepartureFareRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/travelers': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/travelers'
      path: '/travelers'
      fullPath: '/hotels/$id/travelers'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdTravelersRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary'
      path: '/summary'
      fullPath: '/hotels/$id/summary'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms'
      path: '/rooms'
      fullPath: '/hotels/$id/rooms'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/details': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/details'
      path: '/details'
      fullPath: '/hotels/$id/details'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation'
      path: '/confirmation'
      fullPath: '/hotels/$id/confirmation'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images'
      path: '/details/images'
      fullPath: '/hotels/$id/details/images'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images'
      path: '/rooms/$roomToken/images'
      fullPath: '/hotels/$id/rooms/$roomToken/images'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen'
      path: '/details/images/fullscreen'
      fullPath: '/hotels/$id/details/images/fullscreen'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/final': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/final'
      path: '/offer/$id/step/final'
      fullPath: '/flights/offer/$id/step/final'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/3': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/3'
      path: '/offer/$id/step/3'
      fullPath: '/flights/offer/$id/step/3'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep3RouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/1': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/1'
      path: '/offer/$id/step/1'
      fullPath: '/flights/offer/$id/step/1'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep1RouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/'
      path: '/offer/$id/step/2'
      fullPath: '/flights/offer/$id/step/2'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen'
      path: '/rooms/$roomToken/images/fullscreen'
      fullPath: '/hotels/$id/rooms/$roomToken/images/fullscreen'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/'
      path: '/offer/$id/step/2/additional-services'
      fullPath: '/flights/offer/$id/step/2/additional-services'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/meal-selection': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/meal-selection'
      path: '/offer/$id/step/2/additional-services/meal-selection'
      fullPath: '/flights/offer/$id/step/2/additional-services/meal-selection'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
    '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/baggage-selection': {
      id: '/_authenticated/flights/_flights/_flight-offer/offer/$id/step/2/additional-services/baggage-selection'
      path: '/offer/$id/step/2/additional-services/baggage-selection'
      fullPath: '/flights/offer/$id/step/2/additional-services/baggage-selection'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRoute
    }
  }
}

interface AuthenticatedFlightsFlightsFlightOfferRouteRouteChildren {
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route
  AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute
  AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute: typeof AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute
}

const AuthenticatedFlightsFlightsFlightOfferRouteRouteChildren: AuthenticatedFlightsFlightsFlightOfferRouteRouteChildren =
  {
    AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStep1Route,
    AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStep3Route,
    AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStepFinalRoute,
    AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStep2IndexRoute,
    AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesBaggageSelectionRoute,
    AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesMealSelectionRoute,
    AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute:
      AuthenticatedFlightsFlightsFlightOfferOfferIdStep2AdditionalServicesIndexRoute,
  }

const AuthenticatedFlightsFlightsFlightOfferRouteRouteWithChildren =
  AuthenticatedFlightsFlightsFlightOfferRouteRoute._addFileChildren(
    AuthenticatedFlightsFlightsFlightOfferRouteRouteChildren,
  )

interface AuthenticatedFlightsFlightsRouteRouteChildren {
  AuthenticatedFlightsFlightsFlightOfferRouteRoute: typeof AuthenticatedFlightsFlightsFlightOfferRouteRouteWithChildren
  AuthenticatedFlightsFlightsDepartureFareRoute: typeof AuthenticatedFlightsFlightsDepartureFareRoute
  AuthenticatedFlightsFlightsDepartureListRoute: typeof AuthenticatedFlightsFlightsDepartureListRoute
  AuthenticatedFlightsFlightsReturnFareRoute: typeof AuthenticatedFlightsFlightsReturnFareRoute
  AuthenticatedFlightsFlightsReturnListRoute: typeof AuthenticatedFlightsFlightsReturnListRoute
}

const AuthenticatedFlightsFlightsRouteRouteChildren: AuthenticatedFlightsFlightsRouteRouteChildren =
  {
    AuthenticatedFlightsFlightsFlightOfferRouteRoute:
      AuthenticatedFlightsFlightsFlightOfferRouteRouteWithChildren,
    AuthenticatedFlightsFlightsDepartureFareRoute:
      AuthenticatedFlightsFlightsDepartureFareRoute,
    AuthenticatedFlightsFlightsDepartureListRoute:
      AuthenticatedFlightsFlightsDepartureListRoute,
    AuthenticatedFlightsFlightsReturnFareRoute:
      AuthenticatedFlightsFlightsReturnFareRoute,
    AuthenticatedFlightsFlightsReturnListRoute:
      AuthenticatedFlightsFlightsReturnListRoute,
  }

const AuthenticatedFlightsFlightsRouteRouteWithChildren =
  AuthenticatedFlightsFlightsRouteRoute._addFileChildren(
    AuthenticatedFlightsFlightsRouteRouteChildren,
  )

interface AuthenticatedFlightsRouteRouteChildren {
  AuthenticatedFlightsFlightsRouteRoute: typeof AuthenticatedFlightsFlightsRouteRouteWithChildren
  AuthenticatedFlightsExternalRoute: typeof AuthenticatedFlightsExternalRoute
  AuthenticatedFlightsSearchRoute: typeof AuthenticatedFlightsSearchRoute
}

const AuthenticatedFlightsRouteRouteChildren: AuthenticatedFlightsRouteRouteChildren =
  {
    AuthenticatedFlightsFlightsRouteRoute:
      AuthenticatedFlightsFlightsRouteRouteWithChildren,
    AuthenticatedFlightsExternalRoute: AuthenticatedFlightsExternalRoute,
    AuthenticatedFlightsSearchRoute: AuthenticatedFlightsSearchRoute,
  }

const AuthenticatedFlightsRouteRouteWithChildren =
  AuthenticatedFlightsRouteRoute._addFileChildren(
    AuthenticatedFlightsRouteRouteChildren,
  )

interface AuthenticatedHotelsHotelsHotelOfferIdRouteChildren {
  AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
}

const AuthenticatedHotelsHotelsHotelOfferIdRouteChildren: AuthenticatedHotelsHotelsHotelOfferIdRouteChildren =
  {
    AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute:
      AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute,
    AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute:
      AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute,
    AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute,
    AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute:
      AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute,
    AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute:
      AuthenticatedHotelsHotelsHotelOfferIdTravelersRoute,
    AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute:
      AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute,
    AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute:
      AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute,
    AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesRoute,
    AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute,
  }

const AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren =
  AuthenticatedHotelsHotelsHotelOfferIdRoute._addFileChildren(
    AuthenticatedHotelsHotelsHotelOfferIdRouteChildren,
  )

interface AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren {
  AuthenticatedHotelsHotelsHotelOfferIdRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
}

const AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren: AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren =
  {
    AuthenticatedHotelsHotelsHotelOfferIdRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren,
  }

const AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren =
  AuthenticatedHotelsHotelsHotelOfferRouteRoute._addFileChildren(
    AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren,
  )

interface AuthenticatedHotelsHotelsRouteRouteChildren {
  AuthenticatedHotelsHotelsHotelOfferRouteRoute: typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  AuthenticatedHotelsHotelsListRoute: typeof AuthenticatedHotelsHotelsListRoute
}

const AuthenticatedHotelsHotelsRouteRouteChildren: AuthenticatedHotelsHotelsRouteRouteChildren =
  {
    AuthenticatedHotelsHotelsHotelOfferRouteRoute:
      AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren,
    AuthenticatedHotelsHotelsListRoute: AuthenticatedHotelsHotelsListRoute,
  }

const AuthenticatedHotelsHotelsRouteRouteWithChildren =
  AuthenticatedHotelsHotelsRouteRoute._addFileChildren(
    AuthenticatedHotelsHotelsRouteRouteChildren,
  )

interface AuthenticatedHotelsRouteRouteChildren {
  AuthenticatedHotelsHotelsRouteRoute: typeof AuthenticatedHotelsHotelsRouteRouteWithChildren
  AuthenticatedHotelsExternalRoute: typeof AuthenticatedHotelsExternalRoute
  AuthenticatedHotelsSearchRoute: typeof AuthenticatedHotelsSearchRoute
}

const AuthenticatedHotelsRouteRouteChildren: AuthenticatedHotelsRouteRouteChildren =
  {
    AuthenticatedHotelsHotelsRouteRoute:
      AuthenticatedHotelsHotelsRouteRouteWithChildren,
    AuthenticatedHotelsExternalRoute: AuthenticatedHotelsExternalRoute,
    AuthenticatedHotelsSearchRoute: AuthenticatedHotelsSearchRoute,
  }

const AuthenticatedHotelsRouteRouteWithChildren =
  AuthenticatedHotelsRouteRoute._addFileChildren(
    AuthenticatedHotelsRouteRouteChildren,
  )

interface AuthenticatedTripsTripIdRouteRouteChildren {
  AuthenticatedTripsTripIdBookingRoute: typeof AuthenticatedTripsTripIdBookingRoute
  AuthenticatedTripsTripIdSuccessRoute: typeof AuthenticatedTripsTripIdSuccessRoute
  AuthenticatedTripsTripIdSummaryRoute: typeof AuthenticatedTripsTripIdSummaryRoute
  AuthenticatedTripsTripIdTravellersRoute: typeof AuthenticatedTripsTripIdTravellersRoute
  AuthenticatedTripsTripIdIndexRoute: typeof AuthenticatedTripsTripIdIndexRoute
}

const AuthenticatedTripsTripIdRouteRouteChildren: AuthenticatedTripsTripIdRouteRouteChildren =
  {
    AuthenticatedTripsTripIdBookingRoute: AuthenticatedTripsTripIdBookingRoute,
    AuthenticatedTripsTripIdSuccessRoute: AuthenticatedTripsTripIdSuccessRoute,
    AuthenticatedTripsTripIdSummaryRoute: AuthenticatedTripsTripIdSummaryRoute,
    AuthenticatedTripsTripIdTravellersRoute:
      AuthenticatedTripsTripIdTravellersRoute,
    AuthenticatedTripsTripIdIndexRoute: AuthenticatedTripsTripIdIndexRoute,
  }

const AuthenticatedTripsTripIdRouteRouteWithChildren =
  AuthenticatedTripsTripIdRouteRoute._addFileChildren(
    AuthenticatedTripsTripIdRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedFlightsRouteRoute: typeof AuthenticatedFlightsRouteRouteWithChildren
  AuthenticatedHotelsRouteRoute: typeof AuthenticatedHotelsRouteRouteWithChildren
  AuthenticatedBookingsRoute: typeof AuthenticatedBookingsRoute
  AuthenticatedChatRoute: typeof AuthenticatedChatRoute
  AuthenticatedTravelersRoute: typeof AuthenticatedTravelersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTripsTripIdRouteRoute: typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  AuthenticatedTripsSearchRoute: typeof AuthenticatedTripsSearchRoute
  AuthenticatedBookingsScopeIdRoute: typeof AuthenticatedBookingsScopeIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedFlightsRouteRoute: AuthenticatedFlightsRouteRouteWithChildren,
  AuthenticatedHotelsRouteRoute: AuthenticatedHotelsRouteRouteWithChildren,
  AuthenticatedBookingsRoute: AuthenticatedBookingsRoute,
  AuthenticatedChatRoute: AuthenticatedChatRoute,
  AuthenticatedTravelersRoute: AuthenticatedTravelersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTripsTripIdRouteRoute:
    AuthenticatedTripsTripIdRouteRouteWithChildren,
  AuthenticatedTripsSearchRoute: AuthenticatedTripsSearchRoute,
  AuthenticatedBookingsScopeIdRoute: AuthenticatedBookingsScopeIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
